var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { DEALS, RECOGNITION, INSIGHTS, MEDICAL } from "@irati/permissions/constants/products";
import { injectIntl } from "@irati/utils/lang";
import { MobilePerksLogo, MobileRecognitionLogo, MobileInsightsLogo, MobileMedicalLogo } from "@irati/ui/src/Logos";
import Flex from "@irati/ui/src/Flex";
import { Tooltip } from "@irati/ui/src/Tooltip";
var LogoWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  img {\n    height: 36px;\n    width: 36px;\n    ", "\n  }\n"], ["\n  img {\n    height: 36px;\n    width: 36px;\n    ",
    "\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return disabled && "\n      opacity: 0.3;\n      filter: grayscale(1);\n    ";
});
var Products = /** @class */ (function (_super) {
    __extends(Products, _super);
    function Products() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isProductEnabled = function (product) {
            var _a, _b, _c;
            var _d = _this.props, permissionsForTeam = _d.permissionsForTeam, permissionsForTenant = _d.permissionsForTenant;
            if (!permissionsForTeam) {
                return (_a = permissionsForTenant[product.value]) === null || _a === void 0 ? void 0 : _a.enabled;
            }
            return (permissionsForTenant && ((_b = permissionsForTenant[product.value]) === null || _b === void 0 ? void 0 : _b.enabled))
                || ((_c = permissionsForTeam[product.value]) === null || _c === void 0 ? void 0 : _c.enabled);
        };
        _this.getLogo = function (value) {
            switch (value) {
                case RECOGNITION:
                    return React.createElement(MobileRecognitionLogo, null);
                case INSIGHTS:
                    return React.createElement(MobileInsightsLogo, null);
                case MEDICAL:
                    return React.createElement(MobileMedicalLogo, null);
                case DEALS:
                default:
                    return React.createElement(MobilePerksLogo, null);
            }
        };
        return _this;
    }
    Products.prototype.render = function () {
        var _this = this;
        var formatMessage = this.props.formatMessage;
        var products = [
            { label: formatMessage({ id: "admin.components.products.deals" }), value: DEALS },
            { label: formatMessage({ id: "admin.components.products.recognition" }), value: RECOGNITION },
            { label: formatMessage({ id: "admin.components.products.insights" }), value: INSIGHTS },
            { label: formatMessage({ id: "admin.components.products.medical" }), value: MEDICAL }
        ];
        return (React.createElement(Flex, { width: "300px" }, products.map(function (product) {
            var isProductEnabled = _this.isProductEnabled(product);
            return (React.createElement(Flex, { alignItems: "center" },
                React.createElement(Tooltip, { tooltipChildren: product.label, placement: "bottom" },
                    React.createElement(LogoWrapper, { disabled: !isProductEnabled }, _this.getLogo(product.value)))));
        })));
    };
    return Products;
}(PureComponent));
export default injectIntl(Products);
var templateObject_1;
